import React from "react";

import "./hover-anim.css";

export const HoverAnimButton = () => {
    return (
        <div className='button-box'>
            <button className='hover-button'>
                Hover to animate
            </button>
            <div className='hover-bg'/>
        </div>
    )
}